import { render } from "./esco-configuracoes.vue?vue&type=template&id=257b4408&scoped=true"
import script from "./esco-configuracoes.vue?vue&type=script&lang=js"
export * from "./esco-configuracoes.vue?vue&type=script&lang=js"

import "./esco-configuracoes.vue?vue&type=style&index=0&id=257b4408&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257b4408"]])

export default __exports__